/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_Builder_PlaceholderInputs */

const en_ui_filter_builder_placeholder = /** @type {(inputs: Ui_Filter_Builder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ride 50 km "isar"`)
};

const de_ui_filter_builder_placeholder = /** @type {(inputs: Ui_Filter_Builder_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rad 50 km "isar"`)
};

/**
* | output |
* | --- |
* | "ride 50 km \"isar\"" |
*
* @param {Ui_Filter_Builder_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_builder_placeholder = /** @type {((inputs?: Ui_Filter_Builder_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_Builder_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_builder_placeholder(inputs)
	return de_ui_filter_builder_placeholder(inputs)
});